"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryConfiguration_1 = require("./_InventoryConfiguration");
exports.GetBucketInventoryConfigurationOutput = {
    type: "structure",
    required: [],
    members: {
        InventoryConfiguration: {
            shape: _InventoryConfiguration_1._InventoryConfiguration
        }
    },
    payload: "InventoryConfiguration"
};
//# sourceMappingURL=GetBucketInventoryConfigurationOutput.js.map